import type { UseGridFileExportReturn } from "~/hooks/useGridFileExport";

import { createContext } from "react";

const GridFileExportContext = createContext<UseGridFileExportReturn | undefined>(undefined);

export default GridFileExportContext;
